module.exports = __webpack_public_path__ + "img/tb_1.7b11ba56.png";